import type { WidgetId } from '@wix/members-area-app-definitions';
import { getAppDefIdFromWidgetId } from '@wix/members-area-app-definitions';
import { getAppDefinition } from '@wix/members-area-app-definitions/get-app-definitions';
import type { EditorSDK } from '@wix/platform-editor-sdk';

export const getAppDefinitionByWidgetId = async (editorSDK: EditorSDK, widgetId: WidgetId) => {
  const appDefinitionId = getAppDefIdFromWidgetId(widgetId);

  return getAppDefinition({
    editorSDK,
    application: { widgetId, appDefinitionId },
  });
};
